import React from 'react';
import { UitkSelect } from 'uitk-react-select';
import gaLogger from 'src/utils/ga-logger';

type SelectOption = {
    optionLabel: string,
    optionValue: string | number
}

interface SelectProps{
    id: string,
    label: string,
    exClass?: string, 
    invalid?: string,
    value?: string,
    hasVisibleLabel?: boolean,
    options: Array<SelectOption>, 
    onChangeEvent?: (evt: any) => any,
    gaTracking: {
        eventCategory: string;
        eventAction: string;
        eventLabel: string;
    } | undefined,
    initialOption?:{
        label: string;
        value: string;
    }
};

const Select:React.FC<SelectProps> = (props) => {
    const { id , label, exClass,options, onChangeEvent,initialOption, gaTracking, ...rest } = props;
    const selectOptionId = `${id}`;
    
    const onChange = (e) => {        
        if(onChangeEvent){            
            onChangeEvent(e);
        }
        if(gaTracking){            
            const {eventCategory, eventAction, eventLabel} = gaTracking;
            gaLogger.logGa(eventCategory, eventAction, eventLabel);
        }
    }
   
    return (       
        <UitkSelect id={id} label={label} className={exClass} onChange={(e) => onChange(e)} {...rest}   >
            {initialOption && (
                 <option key={`${selectOptionId}-initial-dd`} value={initialOption.value}>{initialOption.label}</option>
            )}
            {options && (
                 options.map((o: SelectOption, i: any) => {
                    const {optionLabel, optionValue} = o;
                    return <option key={`${selectOptionId}-${i}`} value={optionValue}>{optionLabel}</option>
                })
            )}
        </UitkSelect>
    );
};

export { SelectOption, SelectProps, Select };